import { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MapPinIcon, MenuIcon, PhoneIcon, SearchIcon, ShoppingCartIcon } from 'lucide-react';
import { business, images, navigation, routes } from '../data/site';
import { MobileMenu } from './MobileMenu';
import { SiteLink } from './SiteLink';
export function Header() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function onPointerDown(event: MouseEvent) {
      if (navRef.current && !navRef.current.contains(event.target as Node)) {
        setOpenIndex(null);
      }
    }
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpenIndex(null);
    }
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);
  return <>
      <div className="w-full bg-ink" data-id="element-54" data-mp="2rlrhramv5eyu">
        <div className="mx-auto flex max-w-container flex-col gap-1 px-5 py-2 sm:px-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-55" data-mp="2rkq5x3y0wog2">
          <p className="text-[13.5px] leading-5 text-white sm:text-[14px]" data-id="element-56" data-mp="2mmx0we8gi0hd">{business.localBar}</p>
          <div className="hidden shrink-0 items-center gap-5 lg:flex" data-id="element-57" data-mp="2hpeouez57555">
            <a href={business.phoneHref} className="inline-flex items-center gap-1.5 text-[14px] font-medium text-white transition-colors duration-150 ease-out hover:text-water" data-id="element-58" data-mp="3faasrxxas5um">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="35jpuycpg75cr" />
              Call or text {business.phone}
            </a>
            <SiteLink to={routes.location} className="inline-flex items-center gap-1.5 text-[14px] font-medium text-white transition-colors duration-150 ease-out hover:text-water" data-id="element-60" data-mp="30kljtgiyqxjs">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="1rd1jgtpy4hib" />
              Directions
            </SiteLink>
          </div>
        </div>
      </div>

      <header className="sticky top-0 z-40 w-full border-b border-ink/10 bg-white shadow-[0_1px_3px_rgba(20,33,61,0.08)]" data-id="element-62" data-mp="1wbuvsithy2gw">
        <div className="mx-auto flex max-w-container items-center justify-between gap-4 px-5 py-3 sm:px-8" data-id="element-63" data-mp="1mmux70iwp938">
          <SiteLink to={routes.home} className="shrink-0" aria-label="Pegasus Spas and Leisure Products home" data-id="element-64" data-mp="18nbpg8u0bzrg">
            <img src={images.logo} alt="Pegasus Spas & Leisure Products, since 1977" className="h-11 w-auto lg:h-[58px]" width={352} height={140} data-id="element-65" data-mp="1cq00mn671irl" />
          </SiteLink>

          <div ref={navRef} className="hidden flex-1 items-center justify-end gap-6 lg:flex" data-id="element-66" data-mp="2t2f3o1v95ddt">
            <nav aria-label="Main" data-id="element-67" data-mp="2y1rropxv0qhz">
              <ul className="flex flex-nowrap items-center gap-1" data-id="element-68" data-mp="2y0p16j4g8q2l">
                {navigation.map((item, index) => {
                const isOpen = openIndex === index;
                const panelId = `nav-panel-${index}`;
                return <li key={item.label} className="relative" onMouseEnter={() => item.children && setOpenIndex(index)} onMouseLeave={() => item.children && setOpenIndex(null)} data-id="element-69" data-mp="w47riip77nki" data-mpi={index}>
                      <div className="flex items-center" data-id="element-70" data-mp="10630889gl38b">
                        <SiteLink to={item.href} className="whitespace-nowrap rounded-btn px-2 py-2 text-[15.5px] font-medium text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-71" data-mp="105jh4o82o8sp">
                          {item.label}
                        </SiteLink>
                        {item.children && <button type="button" aria-expanded={isOpen} aria-controls={panelId} aria-label={`${item.label} menu`} onClick={() => setOpenIndex(isOpen ? null : index)} className="rounded-btn p-1 text-ink transition-colors duration-150 ease-out hover:text-pegasus-magenta" data-id="element-72" data-mp="3bx6pi669w9qq">
                            <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1k98n1zdaqkdl" />
                          </button>}
                      </div>

                      {item.children && <div id={panelId} hidden={!isOpen} className="absolute left-0 top-full z-50 w-64 rounded-card border border-ink/10 bg-white py-2 shadow-lg" data-id="element-74" data-mp="1t7axf5ix6pdj">
                          <ul data-id="element-75" data-mp="15ihugp3vrh9f">
                            {item.children.map(child => <li key={child.label} data-id="element-76" data-mp="y00imc8j7qda">
                                <SiteLink to={child.href} className="block px-4 py-2 text-[15px] text-ink transition-colors duration-150 ease-out hover:bg-water hover:text-pegasus-blue" data-id="element-77" data-mp="xxo1g1allk1a">
                                  {child.label}
                                </SiteLink>
                              </li>)}
                          </ul>
                        </div>}
                    </li>;
              })}
                <li data-id="element-78" data-mp="5bcsa28xeasv">
                  <SiteLink to={routes.specials} className="whitespace-nowrap rounded-btn px-2 py-2 text-[15.5px] font-bold text-pegasus-magenta transition-colors duration-150 ease-out hover:text-[#bb2f83]" data-id="element-79" data-mp="58qjjzaatp92">
                    Specials
                  </SiteLink>
                </li>
              </ul>
            </nav>

            <div className="flex items-center gap-2 border-l border-ink/10 pl-4" data-id="element-80" data-mp="3drsmelku515r">
              <button type="button" title="Search" aria-label="Search" className="rounded-btn p-2 text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-81" data-mp="3itrqjxoeg23r">
                <SearchIcon className="h-5 w-5" aria-hidden="true" data-id="element-82" data-mp="e7ct9e4hxix" />
              </button>
              <button type="button" title="Cart" aria-label="Cart" className="rounded-btn p-2 text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-83" data-mp="gjv5nnsm9wi">
                <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-84" data-mp="3rs3grylcsxvo" />
              </button>
              <SiteLink to={routes.location} className="ml-1 inline-flex min-h-[44px] items-center whitespace-nowrap rounded-btn bg-pegasus-blue px-4 text-[15px] font-bold text-white transition-colors duration-150 ease-out hover:bg-ink" data-id="element-85" data-mp="jctdin5q9mmb">
                Visit Showroom
              </SiteLink>
            </div>
          </div>

          <div className="flex items-center gap-1 lg:hidden" data-id="element-86" data-mp="2ijqovi1y7ywn">
            <button type="button" title="Search" aria-label="Search" className="flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-87" data-mp="2ij747tkwywex">
              <SearchIcon className="h-5 w-5" aria-hidden="true" data-id="element-88" data-mp="1kx9sqg4ybrch" />
            </button>
            <button type="button" title="Cart" aria-label="Cart" className="flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-89" data-mp="1yw9gllkn427l">
              <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-90" data-mp="369l1byicvlgd" />
            </button>
            <button type="button" aria-label="Open menu" aria-expanded={mobileOpen} onClick={() => setMobileOpen(true)} className="flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-91" data-mp="36bxcnstlyxkg">
              <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-92" data-mp="1ic20316effvq" />
            </button>
          </div>
        </div>

        <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} data-id="element-93" data-mp="1mcdnumu25wbf" />
      </header>
    </>;
}